/**
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 */

/**
 * Formatte le nombre en euros.
 * @type {import("react-intl").FormatNumberOptions}
 * @example 5,00 € (en français)
 */
export const CURRENCY_OPTIONS = {
  style: "currency",
  currency: "EUR",
};

/**
 * Formatte le nombre en pourcent.
 * @example 5,00 %
 */
export const PERCENT_OPTIONS = {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

/**
 * Formatte la date au format standard avec les heures.
 * @example 01/01/2020 14:00 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const SHORT_DATETIME_OPTIONS = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

/**
 * Formatte la date au format long.
 * @example Lundi 1 janvier 2020 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const LONG_DATE_OPTIONS = {
  day: "numeric",
  month: "long",
  year: "numeric",
  weekday: "long",
};

/**
 * Formatte la date avec seulement le mois et l’année.
 * @example Lundi 1 janvier 2020 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const YEAR_MONTH_DATE_OPTIONS = {
  month: "long",
  year: "numeric",
};

/**
 * Formatte la date au format long.
 * @example Lundi 1 janvier 2020 à 14:00 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const LONG_DATETIME_OPTIONS = {
  day: "numeric",
  month: "long",
  year: "numeric",
  weekday: "long",
  hour: "2-digit",
  minute: "2-digit",
};

/**
 * Formatte la date au format court.
 * @example 01/01/2020 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const SHORT_DATE_OPTIONS = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

/**
 * Formatte l'heure au format court.
 * @example 09:18 (en français)
 * @type {import("react-intl").FormatDateOptions}
 */
export const SHORT_TIME_OPTIONS = {
  hour: "2-digit",
  minute: "2-digit",
};
